<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<well-signup-card-layout
  [title]="'signup.account-type.title' | translate"
  [icon]="false"
>
  <div class="types-container" body>
    <div class="item col-lg-3 col-12">
      <well-account-type
        [color]="'#2ECC71'"
        [iconClass]="'fa fa-building'"
        [description]="'signup.account-type.client-description' | translate"
        [title]="'signup.account-type.client' | translate"
        [type]="companyType.customer"
        (nextStep)="onNextStep($event)"
      >
      </well-account-type>
    </div>

    <div class="item col-lg-3 col-12" *ngIf='environmentService.getEnvironmentProperty("accessUnavailableFeatures")'>
      <well-account-type
        [color]="'#ffad00'"
        [iconClass]="'fa fa-building-circle-arrow-right'"
        [description]="translationSchema.signup['account-type']['client-with-fleet-description'] | translate"
        [title]="translationSchema.signup['account-type']['client-with-fleet'] | translate"
        [type]="companyType.customer_with_fleet"
        (nextStep)="onNextStep($event)"
      ></well-account-type>
    </div>

    <div class="item col-lg-3 col-12">
      <well-account-type
        [color]="'#3498DB'"
        [iconClass]="'fa fa-truck-arrow-right'"
        [description]="'signup.account-type.expedition-house-description' | translate"
        [title]="'signup.account-type.expedition-house' | translate"
        [type]="companyType.forwarder"
        (nextStep)="onNextStep($event)"
      ></well-account-type>
    </div>

    <div class="item col-lg-3 col-12">
      <well-account-type
        [color]="'#9B59B6'"
        [iconClass]="'fa fa-truck'"
        [description]="'signup.account-type.vendor-description' | translate"
        [title]="'signup.account-type.vendor' | translate"
        [type]="companyType.service_provider"
        (nextStep)="onNextStep($event)"
      ></well-account-type>
    </div>
  </div>

</well-signup-card-layout>



